import { toLower, toUpper } from "ramda";
import moment from "moment";

// ═══════════════════════════════════════════════════════════════
// ALTAS — Reporte de membresías creadas
// ═══════════════════════════════════════════════════════════════

export const membresias = [
  { name: "requested_by", label: "Solicitado Por", minWidth: 200, align: "center" },
  { name: "created_at", label: "Fecha de Alta", minWidth: 50, align: "center" },
  { name: "status", label: "Estatus", minWidth: 100, align: "center" },
  { name: "person_message", label: "Estatus Creación", minWidth: 150, align: "center" },
  { name: "membership_message", label: "Estatus Membresías", minWidth: 100, align: "center" },
  { name: "enrollment_message", label: "Estatus Inscripción", minWidth: 150, align: "center" },
  { name: "activation_link", label: "Liga Activación", minWidth: 200, align: "center" },
  { name: "student_person_id", label: "Person ID", minWidth: 50, align: "center" },
  { name: "first_name", label: "Nombre", minWidth: 150, align: "center" },
  { name: "last_name", label: "Apellidos", minWidth: 100, align: "center" },
  { name: "email_address", label: "Correo Principal", minWidth: 150, align: "center" },
  { name: "company_name", label: "Empresa", minWidth: 120, align: "center" },
  { name: "group_name", label: "Grupo", minWidth: 120, align: "center" },
  { name: "attribute1_name", label: "Atributo 1", minWidth: 100, align: "center" },
  { name: "attribute2_name", label: "Atributo 2", minWidth: 100, align: "center" },
  { name: "attribute3_name", label: "Atributo 3", minWidth: 100, align: "center" },
  { name: "membership_name", label: "Membresia", minWidth: 150, align: "center" },
  { name: "payment_term", label: "Plazo", minWidth: 100, align: "center" },
  { name: "program_action", label: "Acción Programa Académico", minWidth: 255, align: "center" },
  { name: "program_name", label: "Programa Académico", minWidth: 255, align: "center" },
  { name: "addon_name", label: "Addon-On", minWidth: 255, align: "center" },
];

// ═══════════════════════════════════════════════════════════════
// ALTAS — Excel export
// ═══════════════════════════════════════════════════════════════

export const excelMembershipColumns = [
  { column: "Solicitado Por", type: String, value: (d) => toUpper(d?.requested_by || ''), width: 100 },
  { column: "Fecha de Alta", type: String, value: (d) => toUpper(d?.created_at || ''), width: 50 },
  { column: "Estatus", type: String, value: (d) => toUpper(d?.status || ''), width: 50 },
  { column: "Estatus Creación", type: String, value: (d) => toUpper(d?.person_message || ''), width: 100 },
  { column: "Estatus Membresías", type: String, value: (d) => toUpper(d?.membership_message || ''), width: 100 },
  { column: "Estatus Inscripción", type: String, value: (d) => toUpper(d?.enrollment_message || ''), width: 100 },
  { column: "Liga Activacion", type: String, value: (d) => toUpper(d?.activation_link || ''), width: 100 },
  { column: "Person Id", type: Number, value: (d) => d?.student_person_id || '', width: 50 },
  { column: "Nombre", type: String, value: (d) => toUpper(d?.first_name || ''), width: 50 },
  { column: "Apellidos", type: String, value: (d) => toUpper(d?.last_name || ''), width: 50 },
  { column: "Correo Principal", type: String, value: (d) => toLower(d?.email_address || ''), width: 50 },
  { column: "Empresa", type: String, value: (d) => toUpper(d?.company_name || ''), width: 50 },
  { column: "Grupo", type: String, value: (d) => toUpper(d?.group_name || ''), width: 50 },
  { column: "Atributo 1", type: String, value: (d) => toUpper(d?.attribute1_name || ''), width: 50 },
  { column: "Atributo 2", type: String, value: (d) => toUpper(d?.attribute2_name || ''), width: 50 },
  { column: "Atributo 3", type: String, value: (d) => toUpper(d?.attribute3_name || ''), width: 50 },
  { column: "Membresia", type: String, value: (d) => toUpper(d?.membership_name || ''), width: 50 },
  { column: "Plazo", type: String, value: (d) => toUpper(d?.payment_term || ''), width: 50 },
  { column: "Acción Programa Académico", type: String, value: (d) => toUpper(d?.program_action || ''), width: 50 },
  { column: "Programa", type: String, value: (d) => toUpper(d?.program_name || ''), width: 50 },
  { column: "Addon", type: String, value: (d) => toUpper(d?.addon_name || ''), width: 50 },
];

// ═══════════════════════════════════════════════════════════════
// ALTAS — Formulario de usuarios (tabla preview antes de enviar)
// ═══════════════════════════════════════════════════════════════

export const usersColumns = [
  { name: "fullName", label: "Nombre", minWidth: 150, align: "center" },
  { name: "email", label: "Correo", minWidth: 150, align: "center" },
  { name: "membership", label: "Membresia", format: (item) => item["membership"].label, minWidth: 150, align: "center" },
  { name: "addon", label: "Addon", format: (item) => item["addon"].label, minWidth: 150, align: "center" },
  { name: "program", label: "Programa", format: (item) => item["program"]?.label || "", minWidth: 150, align: "center" },
  { name: "time", label: "Plazo", format: (item) => item["period"]?.label || item["time"] || "", minWidth: 150, align: "center" },
  { name: "group", label: "Grupo", format: (item) => item["group"].label, minWidth: 150, align: "center" },
  { name: "attribute1", label: "Atributo 1", format: (item) => item["attribute1"].label, minWidth: 150, align: "center" },
  { name: "attribute2", label: "Atributo 2", format: (item) => item["attribute2"].label, minWidth: 150, align: "center" },
  { name: "attribute3", label: "Atributo 3", format: (item) => item["attribute3"].label, minWidth: 150, align: "center" },
  { name: "actions", label: "Acciones", minWidth: 150, align: "center" },
];

// ═══════════════════════════════════════════════════════════════
// MODIFICACIONES — Búsqueda de alumnos (tabla principal)
// ═══════════════════════════════════════════════════════════════

export const modificationsSearchColumns = [
  { name: 'id_link', label: 'Id', minWidth: 80, align: 'center' },
  { name: 'user_id', label: 'Matrícula', minWidth: 100, align: 'center' },
  { name: 'full_name', label: 'Nombre completo', minWidth: 180, align: 'center' },
  { name: 'email', label: 'Correo electrónico', minWidth: 200, align: 'center' },
  { name: 'company_name', label: 'Empresa', minWidth: 140, align: 'center' },
  { name: 'membership_name', label: 'Membresía', minWidth: 120, align: 'center' },
  { name: 'start_date_membership', label: 'Inicio Membresía', minWidth: 120, align: 'center' },
  { name: 'end_date_membership', label: 'Fin Membresía', minWidth: 120, align: 'center' },
  { name: 'is_active_icon', label: 'Activo', minWidth: 80, align: 'center' },
  { name: 'actions', label: 'Acciones', minWidth: 80, align: 'center' },
];

// ═══════════════════════════════════════════════════════════════
// MODIFICACIONES — Reporte de operaciones (bajas, extensiones, cambios)
// ═══════════════════════════════════════════════════════════════

export const modificacionesColumns = [
  { name: "requested_by_name", label: "Solicitado Por", minWidth: 150, align: "center" },
  { name: "created_at", label: "Fecha de Operación", minWidth: 120, align: "center" },
  { name: "operation_type", label: "Tipo de Operación", minWidth: 130, align: "center" },
  { name: "status", label: "Estatus", minWidth: 80, align: "center" },
  { name: "student_person_id", label: "Person ID", minWidth: 80, align: "center" },
  { name: "student_name", label: "Nombre", minWidth: 160, align: "center" },
  { name: "student_email", label: "Correo", minWidth: 180, align: "center" },
  { name: "company_name", label: "Empresa", minWidth: 120, align: "center" },
  { name: "group_name", label: "Grupo", minWidth: 100, align: "center" },
  { name: "previous_membership", label: "Membresía Anterior", minWidth: 150, align: "center" },
  { name: "new_membership", label: "Membresía Nueva", minWidth: 150, align: "center" },
  { name: "extension_months", label: "Período Extensión", minWidth: 120, align: "center" },
  { name: "new_expiry_date", label: "Nueva Fecha Expiración", minWidth: 150, align: "center" },
  { name: "result_message", label: "Mensaje Resultado", minWidth: 200, align: "center" },
];

// ═══════════════════════════════════════════════════════════════
// MODIFICACIONES — Reporte Excel export
// ═══════════════════════════════════════════════════════════════

export const excelModificationsColumns = [
  { column: "Solicitado Por", type: String, value: (d) => toUpper(d?.requested_by_name || ''), width: 100 },
  { column: "Fecha de Operación", type: String, value: (d) => d?.created_at || '', width: 80 },
  { column: "Tipo de Operación", type: String, value: (d) => toUpper(d?.operation_type || ''), width: 80 },
  { column: "Estatus", type: String, value: (d) => toUpper(d?.status || ''), width: 50 },
  { column: "Person ID", type: Number, value: (d) => d?.student_person_id || '', width: 50 },
  { column: "Nombre", type: String, value: (d) => toUpper(d?.student_name || ''), width: 80 },
  { column: "Correo", type: String, value: (d) => toLower(d?.student_email || ''), width: 100 },
  { column: "Empresa", type: String, value: (d) => toUpper(d?.company_name || ''), width: 80 },
  { column: "Grupo", type: String, value: (d) => toUpper(d?.group_name || ''), width: 80 },
  { column: "Membresía Anterior", type: String, value: (d) => toUpper(d?.previous_membership || ''), width: 100 },
  { column: "Membresía Nueva", type: String, value: (d) => toUpper(d?.new_membership || ''), width: 100 },
  { column: "Período Extensión", type: String, value: (d) => d?.extension_months ? `${d.extension_months} meses` : '', width: 80 },
  { column: "Nueva Fecha Expiración", type: String, value: (d) => d?.new_expiry_date ? moment(d.new_expiry_date).format('DD/MM/YYYY') : '', width: 100 },
  { column: "Mensaje Resultado", type: String, value: (d) => d?.result_message || '', width: 150 },
];
